import AuthPods from '@/assets/art-auth-pods.svg?react';
import FirstRunPods from '@/assets/art-first-run-pods.svg?react';
import { cn } from '@/shared/lib/cn';

type BrandPodsProps = { variant: 'auth' | 'first-run'; className?: string };

/** The floating Pod tiles on the amber field (motion: [data-pod] in shared/lib/motion). */
export function BrandPods({ variant, className }: BrandPodsProps) {
  const Art = variant === 'auth' ? AuthPods : FirstRunPods;
  return (
    <Art
      aria-hidden="true"
      className={cn('pointer-events-none absolute text-field-ink', className)}
    />
  );
}
